import { useState } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import cn from 'classnames'
import { ArrowListExpand } from '@/utils/icons'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { CourseRowProps, IconComponent } from '../../utils/types'
import styles from '../../index.module.css'

const CloseIcon = CloseOutlined as unknown as IconComponent

const CourseRow = ({ course, children, onReset }: CourseRowProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <div
        className={styles.row}
        onClick={() => setIsOpen((value) => !value)}
      >
        <div className={cn(styles.cell, styles.courseCell)}>
          {course.course_name}
          <span
            className={cn(styles.expandIcon, isOpen && styles.expandIconOpen)}
          >
            <ArrowListExpand />
          </span>
        </div>
        <div className={cn(styles.cell, styles.courseCell)}>
          {course.start_date || '—'}
        </div>
        <div className={cn(styles.cell, styles.courseCell)}>
          {course.end_date || '—'}
        </div>
        <div className={cn(styles.cell, styles.courseCell, styles.center)}>
          {course.course_progress ?? 0} %
        </div>
        <div className={styles.emptyActionCell} />
        <div className={styles.emptyActionCell} />
        <TooltipWrapper title="Сбросить прогресс курса" placement="top">
          <button
            type="button"
            className={styles.resetButton}
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              onReset()
            }}
          >
            <CloseIcon />
          </button>
        </TooltipWrapper>
      </div>
      {isOpen && children}
    </>
  )
}

export default CourseRow
